import { useEffect, useState } from "react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const cutoutUrl = (handle) => `${BACKEND}/api/products/${handle}/image.webp`;

// Show `initial` immediately, then swap to the transparent live cutout once it has fully loaded.
export const useLiveCutout = (handle, initial) => {
  const [state, setState] = useState({ src: initial, live: false });
  useEffect(() => {
    setState({ src: initial, live: false });
    const url = cutoutUrl(handle);
    const pre = new Image();
    pre.onload = () => setState({ src: url, live: true });
    pre.src = url;
    return () => {
      pre.onload = null;
    };
  }, [handle, initial]);
  return state;
};
